<template>
  <div>
    <iframe :src="content" style="width: 100%;height: 96vh;border:none;padding: 0;margin: 0"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content:''
    }
  },
  created() {
    let url = this.$route.path
    console.log(JSON.parse(localStorage.getItem(url)))
    this.content = JSON.parse(localStorage.getItem(url))
  }
}
</script>